'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _RouterActions = require('../../core/actions/RouterActions');

var _appStepRoutes = require('../../core/constants/appStepRoutes');

var _StepConfigInterface = require('../../core/decorators/StepConfigInterface');

var _StepConfigInterface2 = _interopRequireDefault(_StepConfigInterface);

var _Lazy = require('../../core/routeHandlers/Lazy');

var _isNewSignupUx = require('../../core/utils/isNewSignupUx');

var _isNewSignupUx2 = _interopRequireDefault(_isNewSignupUx);

var _availableSteps = require('../config/availableSteps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StandardSignupStepConfig = function StandardSignupStepConfig(stepsParams) {
  return new _StepConfigInterface2.default().addStep(_availableSteps.DefaultDetectAuth).addStep(_availableSteps.DefaultExistingUser).addStep(_availableSteps.JoinHubspotAccount).addStep((0, _availableSteps.JoinHubspotUser)(stepsParams.surveyStep.route)).addStep((0, _availableSteps.DefaultSurveyStep)(stepsParams.surveyStep.route, stepsParams.surveyStep.handler, 2)).addStep(_availableSteps.ExistingAccount).addStep({
    route: _appStepRoutes.DOMAIN,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.DomainOnly, props)
      );
    },
    props: {
      handleSubmit: (0, _isNewSignupUx2.default)() ? _RouterActions.goToStep.bind(null, stepsParams.surveyStep.route) : _RouterActions.goToStep.bind(null, _appStepRoutes.CREATE),
      nextStep: stepsParams.surveyStep.route
    }
  }).addStep({
    route: _appStepRoutes.CREATE,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.Activate, props)
      );
    },
    props: {
      handleUserActivated: (0, _isNewSignupUx2.default)() ? _RouterActions.goToStep.bind(null, stepsParams.surveyStep.route) : _RouterActions.goToStep.bind(null, _appStepRoutes.GETTING_STARTED),
      handleUserNotActivated: _RouterActions.goToStep.bind(null, _appStepRoutes.FORCE_LOGIN)
    }
  }).addStep(_availableSteps.DefaultGettingStarted);
};

exports.default = StandardSignupStepConfig;
module.exports = exports['default'];